import React, {Component} from 'react';

import Header from '../decoration/header';
import OrderPageProgressBar from '../decoration/orderPageProgressBar';
import ListForm from './listForm';
import Footer from '../footer/footer';

import './orderPage2.css';

class OrderPage2 extends Component {
  redirectToSubmitPage = () => {
    this.props.history.push('/order/submit');
  }

  render() {
    return(
      <div className="OrderPage2">
        <Header />
        <OrderPageProgressBar index="2" />
        <ListForm redirectToSubmitPage={this.redirectToSubmitPage} />
        <Footer />
      </div>
    );
  }
}

export default OrderPage2;



// WEBPACK FOOTER //
// ./src/components/orderPage2/orderPage2.js